export const HEALTHCHECK = 'HEALTHCHECK'
export const HEALTHCHECK_SUCCESS = 'HEALTHCHECK_SUCCESS'
export const HEALTHCHECK_FAILURE = 'HEALTHCHECK_FAILURE'
export const AUTH_ERROR = 'AUTH_ERROR'
export const LOGIN = 'LOGIN'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS'
export const CHANGE_PASSWORD_FAILURE = 'CHANGE_PASSWORD_FAILURE'
export const AUTHORIZE = 'AUTHORIZE'
export const AUTHORIZE_FAILURE = 'AUTHORIZE_FAILURE'
export const AUTHORIZE_SUCCESS = 'AUTHORIZE_SUCCESS'
export const LOGOUT = 'LOGOUT'
export const CANNOT_USE = 'CANNOT_USE'

export const NOTICE_COUNT = 'NOTICE_COUNT'
export const NOTICE_COUNT_FAILURE = 'NOTICE_COUNT_FAILURE'
export const NOTICE_COUNT_SUCCESS = 'NOTICE_COUNT_SUCCESS'
export const GET_NOTICE = 'GET_NOTICE'
export const GET_NOTICE_FAILURE = 'GET_NOTICE_FAILURE'
export const GET_NOTICE_SUCCESS = 'GET_NOTICE_SUCCESS'
export const UPDATE_NOTICE_DATE = 'UPDATE_NOTICE_DATE'
export const UPDATE_NOTICE_DATE_FAILURE = 'UPDATE_NOTICE_DATE_FAILURE'
export const UPDATE_NOTICE_DATE_SUCCESS = 'UPDATE_NOTICE_DATE_SUCCESS'

export const ACCESS_CSV = 'ACCESS_CSV'
export const ACCESS_CSV_SUCCESS = 'ACCESS_CSV_SUCCESS'
export const ACCESS_CSV_FAILURE = 'ACCESS_CSV_FAILURE'

export const USER_CSV_DOWNLOAD = 'USER_CSV_DOWNLOAD'
export const USER_CSV_DOWNLOAD_SUCCESS = 'USER_CSV_DOWNLOAD_SUCCESS'
export const USER_CSV_DOWNLOAD_FAILURE = 'USER_CSV_DOWNLOAD_FAILURE'

export const SHOP_SEARCH = 'SHOP_SEARCH'
export const SHOP_SEARCH_SUCCESS = 'SHOP_SEARCH_SUCCESS'
export const SHOP_SEARCH_FAILURE = 'SHOP_SEARCH_FAILURE'
export const SHOP_CLEAR = 'SHOP_CLEAR'
export const CLEAR_AUTH_STATUS = 'CLEAR_AUTH_STATUS'
export const USER_LIST_SEARCH = 'USER_LIST_SEARCH'
export const USER_LIST_SEARCH_FAILURE = 'USER_LIST_SEARCH_FAILURE'
export const USER_LIST_SEARCH_SUCCESS = 'USER_LIST_SEARCH_SUCCESS'
export const USERRETIREE_LIST_SEARCH = 'USERRETIREE_LIST_SEARCH'
export const USERRETIREE_LIST_SEARCH_FAILURE = 'USERRETIREE_LIST_SEARCH_FAILURE'
export const USERRETIREE_LIST_SEARCH_SUCCESS = 'USERRETIREE_LIST_SEARCH_SUCCESS'

export const USER_PDF = 'USER_PDF'
export const USER_PDF_SUCCESS = 'USER_PDF_SUCCESS'
export const USER_PDF_FAILURE = 'USER_PDF_FAILURE'
export const USER_REMOVE = 'USER_REMOVE_PDF'
export const USER_REMOVE_SUCCESS = 'USER_REMOVE_SUCCESS'
export const USER_REMOVE_FAILURE = 'USER_REMOVE_FAILURE'

export const USER_TYPE_CREATE = 'USER_TYPE_CREATE'
export const USER_TYPE_SAVE_FAILURE = 'USER_TYPE_SAVE_FAILURE'
export const USER_TYPE_SAVE_SUCCESS = 'USER_TYPE_SAVE_SUCCESS'
export const USER_TYPE_LIST_SEARCH = 'USER_TYPE_LIST_SEARCH'
export const USER_TYPE_LIST_SEARCH_FAILURE = 'USER_TYPE_LIST_SEARCH_FAILURE'
export const USER_TYPE_LIST_SEARCH_SUCCESS = 'USER_TYPE_LIST_SEARCH_SUCCESS'
export const USER_TYPE_EDIT = 'USER_TYPE_EDIT'
export const USER_TYPE_EDIT_FAILURE = 'USER_TYPE_EDIT_FAILURE'
export const USER_TYPE_EDIT_SUCCESS = 'USER_TYPE_EDIT_SUCCESS'
export const USER_TYPE_UPDATE = 'USER_TYPE_UPDATE'
export const USER_TYPE_UPDATE_FAILURE = 'USER_TYPE_UPDATE_FAILURE'
export const USER_TYPE_UPDATE_SUCCESS = 'USER_TYPE_UPDATE_SUCCESS'
export const USER_TYPE_DELETE = 'USER_TYPE_DELETE'
export const USER_TYPE_DELETE_FAILURE = 'USER_TYPE_DELETE_FAILURE'
export const USER_TYPE_DELETE_SUCCESS = 'USER_TYPE_DELETE_SUCCESS'

export const DOMAIN_CREATE = 'DOMAIN_CREATE'
export const DOMAIN_SAVE_FAILURE = 'DOMAIN_SAVE_FAILURE'
export const DOMAIN_SAVE_SUCCESS = 'DOMAIN_SAVE_SUCCESS'
export const DOMAIN_LIST_SEARCH = 'DOMAIN_LIST_SEARCH'
export const DOMAIN_LIST_SEARCH_FAILURE = 'DOMAIN_LIST_SEARCH_FAILURE'
export const DOMAIN_LIST_SEARCH_SUCCESS = 'DOMAIN_LIST_SEARCH_SUCCESS'
export const DOMAIN_EDIT = 'DOMAIN_EDIT'
export const DOMAIN_EDIT_FAILURE = 'DOMAIN_EDIT_FAILURE'
export const DOMAIN_EDIT_SUCCESS = 'DOMAIN_EDIT_SUCCESS'
export const DOMAIN_UPDATE = 'DOMAIN_UPDATE'
export const DOMAIN_UPDATE_FAILURE = 'DOMAIN_UPDATE_FAILURE'
export const DOMAIN_UPDATE_SUCCESS = 'DOMAIN_UPDATE_SUCCESS'
export const DOMAIN_DELETE = 'DOMAIN_DELETE'
export const DOMAIN_DELETE_FAILURE = 'DOMAIN_DELETE_FAILURE'
export const DOMAIN_DELETE_SUCCESS = 'DOMAIN_DELETE_SUCCESS'

export const BUSINESS_TYPE_CREATE = 'BUSINESS_TYPE_CREATE'
export const BUSINESS_TYPE_SAVE_FAILURE = 'BUSINESS_TYPE_SAVE_FAILURE'
export const BUSINESS_TYPE_SAVE_SUCCESS = 'BUSINESS_TYPE_SAVE_SUCCESS'
export const BUSINESS_TYPE_LIST_SEARCH = 'BUSINESS_TYPE_LIST_SEARCH'
export const BUSINESS_TYPE_LIST_SEARCH_FAILURE = 'BUSINESS_TYPE_LIST_SEARCH_FAILURE'
export const BUSINESS_TYPE_LIST_SEARCH_SUCCESS = 'BUSINESS_TYPE_LIST_SEARCH_SUCCESS'
export const BUSINESS_TYPE_EDIT = 'BUSINESS_TYPE_EDIT'
export const BUSINESS_TYPE_EDIT_FAILURE = 'BUSINESS_TYPE_EDIT_FAILURE'
export const BUSINESS_TYPE_EDIT_SUCCESS = 'BUSINESS_TYPE_EDIT_SUCCESS'
export const BUSINESS_TYPE_UPDATE = 'BUSINESS_TYPE_UPDATE'
export const BUSINESS_TYPE_UPDATE_FAILURE = 'BUSINESS_TYPE_UPDATE_FAILURE'
export const BUSINESS_TYPE_UPDATE_SUCCESS = 'BUSINESS_TYPE_UPDATE_SUCCESS'
export const BUSINESS_TYPE_DELETE = 'BUSINESS_TYPE_DELETE'
export const BUSINESS_TYPE_DELETE_FAILURE = 'BUSINESS_TYPE_DELETE_FAILURE'
export const BUSINESS_TYPE_DELETE_SUCCESS = 'BUSINESS_TYPE_DELETE_SUCCESS'

export const TURNOVER_CREATE = 'TURNOVER_CREATE'
export const TURNOVER_SAVE_FAILURE = 'TURNOVER_SAVE_FAILURE'
export const TURNOVER_SAVE_SUCCESS = 'TURNOVER_SAVE_SUCCESS'
export const TURNOVER_LIST_SEARCH = 'TURNOVER_LIST_SEARCH'
export const TURNOVER_LIST_SEARCH_FAILURE = 'TURNOVER_LIST_SEARCH_FAILURE'
export const TURNOVER_LIST_SEARCH_SUCCESS = 'TURNOVER_LIST_SEARCH_SUCCESS'
export const TURNOVER_EDIT = 'TURNOVER_EDIT'
export const TURNOVER_EDIT_FAILURE = 'TURNOVER_EDIT_FAILURE'
export const TURNOVER_EDIT_SUCCESS = 'TURNOVER_EDIT_SUCCESS'
export const TURNOVER_UPDATE = 'TURNOVER_UPDATE'
export const TURNOVER_UPDATE_FAILURE = 'TURNOVER_UPDATE_FAILURE'
export const TURNOVER_UPDATE_SUCCESS = 'TURNOVER_UPDATE_SUCCESS'
export const TURNOVER_DELETE = 'TURNOVER_DELETE'
export const TURNOVER_DELETE_FAILURE = 'TURNOVER_DELETE_FAILURE'
export const TURNOVER_DELETE_SUCCESS = 'TURNOVER_DELETE_SUCCESS'

export const JOIN_CREATE = 'JOIN_CREATE'
export const JOIN_SAVE_FAILURE = 'JOIN_SAVE_FAILURE'
export const JOIN_SAVE_SUCCESS = 'JOIN_SAVE_SUCCESS'
export const JOIN_LIST_SEARCH = 'JOIN_LIST_SEARCH'
export const JOIN_LIST_SEARCH_FAILURE = 'JOIN_LIST_SEARCH_FAILURE'
export const JOIN_LIST_SEARCH_SUCCESS = 'JOIN_LIST_SEARCH_SUCCESS'
export const JOIN_EDIT = 'JOIN_EDIT'
export const JOIN_EDIT_FAILURE = 'JOIN_EDIT_FAILURE'
export const JOIN_EDIT_SUCCESS = 'JOIN_EDIT_SUCCESS'
export const JOIN_UPDATE = 'JOIN_UPDATE'
export const JOIN_UPDATE_FAILURE = 'JOIN_UPDATE_FAILURE'
export const JOIN_UPDATE_SUCCESS = 'JOIN_UPDATE_SUCCESS'
export const JOIN_DELETE = 'JOIN_DELETE'
export const JOIN_DELETE_FAILURE = 'JOIN_DELETE_FAILURE'
export const JOIN_DELETE_SUCCESS = 'JOIN_DELETE_SUCCESS'

export const USER_CREATE = 'USER_CREATE'
export const USER_CREATE_FAILURE = 'USER_CREATE_FAILURE'
export const USER_CREATE_SUCCESS = 'USER_CREATE_SUCCESS'
export const USER_NEW = 'USER_NEW'
export const USER_NEW_SUCCESS = 'USER_NEW_SUCCESS'
export const USER_NEW_FAILURE = 'USER_NEW_FAILURE'
export const KANA_GET = 'KANA_GET'
export const KANA_GET_SUCCESS = 'KANA_GET_SUCCESS'
export const KANA_GET_FAILURE = 'KANA_GET_FAILURE'
export const USER_SHOPS = 'USER_SHOPS'
export const USER_SHOPS_SUCCESS = 'USER_SHOPS_SUCCESS'
export const USER_SHOPS_FAILURE = 'USER_SHOPS_FAILURE'
export const USER_SHOPS_CLEAR = 'USER_SHOPS_CLEAR'
export const USER_DETAIL = 'USER_DETAIL'
export const USER_DETAIL_FAILURE = 'USER_DETAIL_FAILURE'
export const USER_DETAIL_SUCCESS = 'USER_DETAIL_SUCCESS'
export const USER_EDIT = 'USER_EDIT'
export const USER_EDIT_FAILURE = 'USER_EDIT_FAILURE'
export const USER_EDIT_SUCCESS = 'USER_EDIT_SUCCESS'
export const USER_EDIT_SHOPS = 'USER_EDIT_SHOPS'
export const USER_EDIT_SHOPS_SUCCESS = 'USER_EDIT_SHOPS_SUCCESS'
export const USER_EDIT_SHOPS_FAILURE = 'USER_EDIT_SHOPS_FAILURE'
export const USER_EDIT_SHOPS_CLEAR = 'USER_EDIT_SHOPS_CLEAR'
export const USER_UPDATE = 'USER_UPDATE'
export const USER_UPDATE_SUCCESS = 'USER_UPDATE_SUCCESS'
export const USER_UPDATE_FAILURE = 'USER_UPDATE_FAILURE'
export const USER_DELETE = 'USER_DELETE'
export const USER_DELETE_SUCCESS = 'USER_DELETE_SUCCESS'
export const USER_DELETE_FAILURE = 'USER_DELETE_FAILURE'
export const USER_UPLOAD_START = 'USER_UPLOAD_START'
export const USER_AVARTAR_UPLOAD = 'USER_AVARTAR_UPLOAD'
export const USER_AVARTAR_UPLOAD_SUCCESS = 'USER_AVARTAR_UPLOAD_SUCCESS'
export const USER_AVARTAR_UPLOAD_FAILURE = 'USER_AVARTAR_UPLOAD_FAILURE'
export const USEROVER_UPDATE = 'USEROVER_UPDATE'
export const USEROVER_UPDATE_SUCCESS = 'USEROVER_UPDATE_SUCCESS'
export const USEROVER_UPDATE_FAILURE = 'USEROVER_UPDATE_FAILURE'
export const USEROVER_CANCEL = 'USEROVER_CANCEL'
export const USEROVER_CANCEL_SUCCESS = 'USEROVER_CANCEL_SUCCESS'
export const USEROVER_CANCEL_FAILURE = 'USEROVER_CANCEL_FAILURE'
export const UPLOAD_PDF_FILE = 'UPLOAD_PDF_FILE'
export const UPLOAD_PDF_FILE_SUCCESS = 'UPLOAD_PDF_FILE_SUCCESS'
export const UPLOAD_PDF_FILE_FAILURE = 'UPLOAD_PDF_FILE_FAILURE'
export const SAVE_PDF_FILE = 'SAVE_PDF_FILE'
export const SAVE_PDF_FILE_SUCCESS = 'SAVE_PDF_FILE_SUCCESS'
export const SAVE_PDF_FILE_FAILURE = 'SAVE_PDF_FILE_FAILURE'
export const SEARCH_PDF_FILE = 'SEARCH_PDF_FILE'
export const SEARCH_PDF_FILE_SUCCESS = 'SEARCH_PDF_FILE_SUCCESS'
export const SEARCH_PDF_FILE_FAILURE = 'SEARCH_PDF_FILE_FAILURE'
export const DELETE_PDF_FILE = 'DELETE_PDF_FILE'
export const DELETE_PDF_FILE_SUCCESS = 'DELETE_PDF_FILE_SUCCESS'
export const DELETE_PDF_FILE_FAILURE = 'DELETE_PDF_FILE_FAILURE'
export const DELETE_PATH = 'DELETE_PATH'
export const DELETE_PATH_SUCCESS = 'DELETE_PATH_SUCCESS'
export const DELETE_PATH_FAILURE = 'DELETE_PATH_FAILURE'

export const SHOPHISTORY_CREATE = 'SHOPHISTORY_CREATE'
export const SHOPHISTORY_CREATE_SUCCESS = 'SHOPHISTORY_CREATE_SUCCESS'
export const SHOPHISTORY_CREATE_FAILURE = 'SHOPHISTORY_CREATE_FAILURE'
export const SHOPHISTORY_ALL_UPDATE = 'SHOPHISTORY_ALL_UPDATE'
export const SHOPHISTORY_ALL_UPDATE_SUCCESS = 'SHOPHISTORY_ALL_UPDATE_SUCCESS'
export const SHOPHISTORY_ALL_UPDATE_FAILURE = 'SHOPHISTORY_ALL_UPDATE_FAILURE'
export const SHOPHISTORY_CANCEL = 'SHOPHISTORY_CANCEL'
export const SHOPHISTORY_CANCEL_SUCCESS = 'SHOPHISTORY_CANCEL_SUCCESS'
export const SHOPHISTORY_CANCEL_FAILURE = 'SHOPHISTORY_CANCEL_FAILURE'

export const USERTYPEHISTORY_CREATE = 'USERTYPEHISTORY_CREATE'
export const USERTYPEHISTORY_CREATE_SUCCESS = 'USERTYPEHISTORY_CREATE_SUCCESS'
export const USERTYPEHISTORY_CREATE_FAILURE = 'USERTYPEHISTORY_CREATE_FAILURE'
export const USERTYPEHISTORY_ALL_UPDATE = 'USERTYPEHISTORY_ALL_UPDATE'
export const USERTYPEHISTORY_ALL_UPDATE_SUCCESS = 'USERTYPEHISTORY_ALL_UPDATE_SUCCESS'
export const USERTYPEHISTORY_ALL_UPDATE_FAILURE = 'USERTYPEHISTORY_ALL_UPDATE_FAILURE'
export const USERTYPEHISTORY_CANCEL = 'USERTYPEHISTORY_CANCEL'
export const USERTYPEHISTORY_CANCEL_SUCCESS = 'USERTYPEHISTORY_CANCEL_SUCCESS'
export const USERTYPEHISTORY_CANCEL_FAILURE = 'USERTYPEHISTORY_CANCEL_FAILURE'

export const SHOP_LIST_SEARCH = 'SHOP_LIST_SEARCH'
export const SHOP_LIST_SEARCH_FAILURE = 'SHOP_LIST_SEARCH_FAILURE'
export const SHOP_LIST_SEARCH_SUCCESS = 'SHOP_LIST_SEARCH_SUCCESS'

export const SHOP_ALL_GET = 'SHOP_ALL_GET'
export const SHOP_ALL_GET_FAILURE = 'SHOP_ALL_GET_FAILURE'
export const SHOP_ALL_GET_SUCCESS = 'SHOP_ALL_GET_SUCCESS'
export const GET_SHOP_TARGET_STOCK = 'GET_SHOP_TARGET_STOCK'

export const USERTYPE_ALL_GET = 'USERTYPE_ALL_GET'
export const USERTYPE_ALL_GET_FAILURE = 'USERTYPE_ALL_GET_FAILURE'
export const USERTYPE_ALL_GET_SUCCESS = 'USERTYPE_ALL_GET_SUCCESS'

export const SHOP_NEW = 'SHOP_NEW'
export const SHOP_NEW_FAILURE = 'SHOP_NEW_FAILURE'
export const SHOP_NEW_SUCCESS = 'SHOP_NEW_SUCCESS'
export const SHOP_CREATE = 'SHOP_CREATE'
export const SHOP_CREATE_FAILURE = 'SHOP_CREATE_FAILURE'
export const SHOP_CREATE_SUCCESS = 'SHOP_CREATE_SUCCESS'
export const SHOP_DETAIL = 'SHOP_DETAIL'
export const SHOP_DETAIL_FAILURE = 'SHOP_DETAIL_FAILURE'
export const SHOP_DETAIL_SUCCESS = 'SHOP_DETAIL_SUCCESS'
export const SHOP_EDIT = 'SHOP_EDIT'
export const SHOP_EDIT_FAILURE = 'SHOP_EDIT_FAILURE'
export const SHOP_EDIT_SUCCESS = 'SHOP_EDIT_SUCCESS'
export const SHOP_UPDATE = 'SHOP_UPDATE'
export const SHOP_UPDATE_FAILURE = 'SHOP_UPDATE_FAILURE'
export const SHOP_UPDATE_SUCCESS = 'SHOP_UPDATE_SUCCESS'
export const SHOP_DELETE = 'SHOP_DELETE'
export const SHOP_DELETE_SUCCESS = 'SHOP_DELETE_SUCCESS'
export const SHOP_DELETE_FAILURE = 'SHOP_DELETE_FAILURE'
export const SHOP_USER_LIST = 'SHOP_USER_LIST'
export const SHOP_USER_LIST_FAILURE = 'SHOP_USER_LIST_FAILURE'
export const SHOP_USER_LIST_SUCCESS = 'SHOP_USER_LIST_SUCCESS'

export const PASSWORD_RESET_MAIL_SEND = 'PASSWORD_RESET_MAIL_SEND'
export const PASSWORD_RESET_MAIL_SEND_SUCCESS = 'PASSWORD_RESET_MAIL_SEND_SUCCESS'
export const PASSWORD_RESET_MAIL_SEND_FAILURE = 'PASSWORD_RESET_MAIL_SEND_FAILURE'
export const PASSWORD_RESET_UPDATE = 'PASSWORD_RESET_UPDATE'
export const PASSWORD_RESET_UPDATE_SUCCESS = 'PASSWORD_RESET_UPDATE_SUCCESS'
export const PASSWORD_RESET_UPDATE_FAILURE = 'PASSWORD_RESET_UPDATE_FAILURE'

export const IMAGE_UPLOAD_START = 'IMAGE_UPLOAD_START'
export const IMAGE_UPLOAD = 'IMAGE_UPLOAD'
export const IMAGE_UPLOAD_SUCCESS = 'IMAGE_UPLOAD_SUCCESS'
export const IMAGE_UPLOAD_FAILURE = 'IMAGE_UPLOAD_FAILURE'

export const ADDRESS_GET = 'ADDRESS_GET'
export const ADDRESS_GET_SUCCESS = 'ADDRESS_GET_SUCCESS'
export const ADDRESS_GET_FAILURE = 'ADDRESS_GET_FAILURE'

export const USER_PHOTO_PDF = 'USER_PHOTO_PDF'
export const USER_PHOTO_PDF_SUCCESS = 'USER_PHOTO_PDF_SUCCESS'
export const USER_PHOTO_PDF_FAILURE = 'USER_PHOTO_PDF_FAILURE'

export const USER_PHOTO_PDF_REMOVE = 'USER_PHOTO_PDF_REMOVE'
export const USER_PHOTO_PDF_REMOVE_SUCCESS = 'USER_PHOTO_PDF_REMOVE_SUCCESS'
export const USER_PHOTO_PDF_REMOVE_FAILURE = 'USER_PHOTO_PDF_REMOVE_FAILURE'

export const USER_DETAIL_PDF = 'USER_DETAIL_PDF'
export const USER_DETAIL_PDF_SUCCESS = 'USER_DETAIL_PDF_SUCCESS'
export const USER_DETAIL_PDF_FAILURE = 'USER_DETAIL_PDF_FAILURE'

export const USER_DETAIL_PDF_REMOVE = 'USER_DETAIL_PDF_REMOVE'
export const USER_DETAIL_PDF_REMOVE_SUCCESS = 'USER_DETAIL_PDF_REMOVE_SUCCESS'
export const USER_DETAIL_PDF_REMOVE_FAILURE = 'USER_DETAIL_PDF_REMOVE_FAILURE'

export const MORAL_LIST_SEARCH = 'MORAL_LIST_SEARCH'
export const MORAL_LIST_SEARCH_FAILURE = 'MORAL_LIST_SEARCH_FAILURE'
export const MORAL_LIST_SEARCH_SUCCESS = 'MORAL_LIST_SEARCH_SUCCESS'
export const MORAL_EDIT = 'MORAL_EDIT'
export const MORAL_EDIT_FAILURE = 'MORAL_EDIT_FAILURE'
export const MORAL_EDIT_SUCCESS = 'MORAL_EDIT_SUCCESS'
export const MORAL_UPDATE = 'MORAL_UPDATE'
export const MORAL_UPDATE_FAILURE = 'MORAL_UPDATE_FAILURE'
export const MORAL_UPDATE_SUCCESS = 'MORAL_UPDATE_SUCCESS'
export const MORAL_DELETE = 'MORAL_DELETE'
export const MORAL_DELETE_FAILURE = 'MORAL_DELETE_FAILURE'
export const MORAL_DELETE_SUCCESS = 'MORAL_DELETE_SUCCESS'
export const MORAL_CREATE = 'MORAL_CREATE'
export const MORAL_CREATE_FAILURE = 'MORAL_CREATE_FAILURE'
export const MORAL_CREATE_SUCCESS = 'MORAL_CREATE_SUCCESS'
export const MORAL_IMAGE_UPLOAD = 'MORAL_IMAGE_UPLOAD'
export const MORAL_IMAGE_UPLOAD_FAILURE = 'MORAL_IMAGE_UPLOAD_FAILURE'
export const MORAL_IMAGE_UPLOAD_SUCCESS = 'MORAL_IMAGE_UPLOAD_SUCCESS'
export const MORAL_RESULT_LIST_SEARCH = 'MORAL_RESULT_LIST_SEARCH'
export const MORAL_RESULT_LIST_SEARCH_FAILURE = 'MORAL_RESULT_LIST_SEARCH_FAILURE'
export const MORAL_RESULT_LIST_SEARCH_SUCCESS = 'MORAL_RESULT_LIST_SEARCH_SUCCESS'
export const MORAL_RESULT_DATA_DOWNLOAD = 'MORAL_RESULT_DATA_DOWNLOAD'
export const MORAL_RESULT_DATA_DOWNLOAD_FAILURE = 'MORAL_RESULT_DATA_DOWNLOAD_FAILURE'
export const MORAL_RESULT_DATA_DOWNLOAD_SUCCESS = 'MORAL_RESULT_DATA_DOWNLOAD_SUCCESS'
export const MORAL_ALL_GET = 'MORAL_ALL_GET'
export const MORAL_ALL_GET_FAILURE = 'MORAL_ALL_GET_FAILURE'
export const MORAL_ALL_GET_SUCCESS = 'MORAL_ALL_GET_SUCCESS'

export const REJECT_REASON_CREATE = 'REJECT_REASON_CREATE'
export const REJECT_REASON_SAVE_FAILURE = 'REJECT_REASON_SAVE_FAILURE'
export const REJECT_REASON_SAVE_SUCCESS = 'REJECT_REASON_SAVE_SUCCESS'
export const REJECT_REASON_LIST_SEARCH = 'REJECT_REASON_LIST_SEARCH'
export const REJECT_REASON_LIST_SEARCH_FAILURE = 'REJECT_REASON_LIST_SEARCH_FAILURE'
export const REJECT_REASON_LIST_SEARCH_SUCCESS = 'REJECT_REASON_LIST_SEARCH_SUCCESS'
export const REJECT_REASON_EDIT = 'REJECT_REASON_EDIT'
export const REJECT_REASON_EDIT_FAILURE = 'REJECT_REASON_EDIT_FAILURE'
export const REJECT_REASON_EDIT_SUCCESS = 'REJECT_REASON_EDIT_SUCCESS'
export const REJECT_REASON_UPDATE = 'REJECT_REASON_UPDATE'
export const REJECT_REASON_UPDATE_FAILURE = 'REJECT_REASON_UPDATE_FAILURE'
export const REJECT_REASON_UPDATE_SUCCESS = 'REJECT_REASON_UPDATE_SUCCESS'
export const REJECT_REASON_DELETE = 'REJECT_REASON_DELETE'
export const REJECT_REASON_DELETE_FAILURE = 'REJECT_REASON_DELETE_FAILURE'
export const REJECT_REASON_DELETE_SUCCESS = 'REJECT_REASON_DELETE_SUCCESS'
export const REJECT_REASON_ALL_GET = 'REJECT_REASON_ALL_GET'
export const REJECT_REASON_ALL_GET_FAILURE = 'REJECT_REASON_ALL_GET_FAILURE'
export const REJECT_REASON_ALL_GET_SUCCESS = 'REJECT_REASON_ALL_GET_SUCCESS'

export const GUIDELINE_CREATE = 'GUIDELINE_CREATE'
export const GUIDELINE_SAVE_FAILURE = 'GUIDELINE_SAVE_FAILURE'
export const GUIDELINE_SAVE_SUCCESS = 'GUIDELINE_SAVE_SUCCESS'
export const GUIDELINE_LIST_SEARCH = 'GUIDELINE_LIST_SEARCH'
export const GUIDELINE_LIST_SEARCH_FAILURE = 'GUIDELINE_LIST_SEARCH_FAILURE'
export const GUIDELINE_LIST_SEARCH_SUCCESS = 'GUIDELINE_LIST_SEARCH_SUCCESS'
export const GUIDELINE_EDIT = 'GUIDELINE_EDIT'
export const GUIDELINE_EDIT_FAILURE = 'GUIDELINE_EDIT_FAILURE'
export const GUIDELINE_EDIT_SUCCESS = 'GUIDELINE_EDIT_SUCCESS'
export const GUIDELINE_UPDATE = 'GUIDELINE_UPDATE'
export const GUIDELINE_UPDATE_FAILURE = 'GUIDELINE_UPDATE_FAILURE'
export const GUIDELINE_UPDATE_SUCCESS = 'GUIDELINE_UPDATE_SUCCESS'
export const GUIDELINE_DELETE = 'GUIDELINE_DELETE'
export const GUIDELINE_DELETE_FAILURE = 'GUIDELINE_DELETE_FAILURE'
export const GUIDELINE_DELETE_SUCCESS = 'GUIDELINE_DELETE_SUCCESS'
export const GUIDELINE_ALL_GET = 'GUIDELINE_ALL_GET'
export const GUIDELINE_ALL_GET_FAILURE = 'GUIDELINE_ALL_GET_FAILURE'
export const GUIDELINE_ALL_GET_SUCCESS = 'GUIDELINE_ALL_GET_SUCCESS'

export const PROPOSE_UNAPPROVED_LIST_SEARCH = 'PROPOSE_UNAPPROVED_LIST_SEARCH'
export const PROPOSE_UNAPPROVED_LIST_SEARCH_FAILURE = 'PROPOSE_UNAPPROVED_LIST_SEARCH_FAILURE'
export const PROPOSE_UNAPPROVED_LIST_SEARCH_SUCCESS = 'PROPOSE_UNAPPROVED_LIST_SEARCH_SUCCESS'
export const PROPOSE_APPROVED_LIST_SEARCH = 'PROPOSE_APPROVED_LIST_SEARCH'
export const PROPOSE_APPROVED_LIST_SEARCH_FAILURE = 'PROPOSE_APPROVED_LIST_SEARCH_FAILURE'
export const PROPOSE_APPROVED_LIST_SEARCH_SUCCESS = 'PROPOSE_APPROVED_LIST_SEARCH_SUCCESS'
export const PROPOSE_COUNT = 'PROPOSE_COUNT'
export const PROPOSE_COUNT_FAILURE = 'PROPOSE_COUNT_FAILURE'
export const PROPOSE_COUNT_SUCCESS = 'PROPOSE_COUNT_SUCCESS'
export const PROPOSE_DETAIL = 'PROPOSE_DETAIL'
export const PROPOSE_DETAIL_FAILURE = 'PROPOSE_DETAIL_FAILURE'
export const PROPOSE_DETAIL_SUCCESS = 'PROPOSE_DETAIL_SUCCESS'
export const PROPOSE_APPROVE = 'PROPOSE_APPROVE'
export const PROPOSE_APPROVE_FAILURE = 'PROPOSE_APPROVE_FAILURE'
export const PROPOSE_APPROVE_SUCCESS = 'PROPOSE_APPROVE_SUCCESS'
export const PROPOSE_ADOPT = 'PROPOSE_ADOPT'
export const PROPOSE_ADOPT_FAILURE = 'PROPOSE_ADOPT_FAILURE'
export const PROPOSE_ADOPT_SUCCESS = 'PROPOSE_ADOPT_SUCCESS'
export const PROPOSE_NOT_APPROVE = 'PROPOSE_NOT_APPROVE'
export const PROPOSE_NOT_APPROVE_FAILURE = 'PROPOSE_NOT_APPROVE_FAILURE'
export const PROPOSE_NOT_APPROVE_SUCCESS = 'PROPOSE_NOT_APPROVE_SUCCESS'
export const PROPOSE_RESULT_DATA_DOWNLOAD = 'PROPOSE_RESULT_DATA_DOWNLOAD'
export const PROPOSE_RESULT_DATA_DOWNLOAD_FAILURE = 'PROPOSE_RESULT_DATA_DOWNLOAD_FAILURE'
export const PROPOSE_RESULT_DATA_DOWNLOAD_SUCCESS = 'PROPOSE_RESULT_DATA_DOWNLOAD_SUCCESS'
export const PROPOSE_TASK_LIST = 'PROPOSE_TASK_LIST'
export const PROPOSE_TASK_LIST_FAILURE = 'PROPOSE_TASK_LIST_FAILURE'
export const PROPOSE_TASK_LIST_SUCCESS = 'PROPOSE_TASK_LIST_SUCCESS'
export const PROPOSE_TASK_CREATE = 'PROPOSE_TASK_CREATE'
export const PROPOSE_TASK_CREATE_FAILURE = 'PROPOSE_TASK_CREATE_FAILURE'
export const PROPOSE_TASK_CREATE_SUCCESS = 'PROPOSE_TASK_CREATE_SUCCESS'
export const PROPOSE_TASK_DETAIL = 'PROPOSE_TASK_DETAIL'
export const PROPOSE_TASK_DETAIL_FAILURE = 'PROPOSE_TASK_DETAIL_FAILURE'
export const PROPOSE_TASK_DETAIL_SUCCESS = 'PROPOSE_TASK_DETAIL_SUCCESS'
export const PROPOSE_TASK_DELETE = 'PROPOSE_TASK_DELETE'
export const PROPOSE_TASK_DELETE_FAILURE = 'PROPOSE_TASK_DELETE_FAILURE'
export const PROPOSE_TASK_DELETE_SUCCESS = 'PROPOSE_TASK_DELETE_SUCCESS'
export const PROPOSE_TASK_UPDATE = 'PROPOSE_TASK_UPDATE'
export const PROPOSE_TASK_UPDATE_FAILURE = 'PROPOSE_TASK_UPDATE_FAILURE'
export const PROPOSE_TASK_UPDATE_SUCCESS = 'PROPOSE_TASK_UPDATE_SUCCESS'

export const SHOP_MANAGER_LIST_SEARCH = 'SHOP_MANAGER_LIST_SEARCH'
export const SHOP_MANAGER_LIST_SEARCH_FAILURE = 'SHOP_MANAGER_LIST_SEARCH_FAILURE'
export const SHOP_MANAGER_LIST_SEARCH_SUCCESS = 'SHOP_MANAGER_LIST_SEARCH_SUCCESS'
export const SHOP_MANAGER_EDIT_SEARCH = 'SHOP_MANAGER_EDIT_SEARCH'
export const SHOP_MANAGER_EDIT_SEARCH_FAILURE = 'SHOP_MANAGER_EDIT_SEARCH_FAILURE'
export const SHOP_MANAGER_EDIT_SEARCH_SUCCESS = 'SHOP_MANAGER_EDIT_SEARCH_SUCCESS'
export const SHOP_MANAGER_UPDATE = 'SHOP_MANAGER_UPDATE'
export const SHOP_MANAGER_UPDATE_FAILURE = 'SHOP_MANAGER_UPDATE_FAILURE'
export const SHOP_MANAGER_UPDATE_SUCCESS = 'SHOP_MANAGER_UPDATE_SUCCESS'

export const MESSAGE_DATA_DOWNLOAD = 'MESSAGE_DATA_DOWNLOAD'
export const MESSAGE_DATA_DOWNLOAD_FAILURE = 'MESSAGE_DATA_DOWNLOAD_FAILURE'
export const MESSAGE_DATA_DOWNLOAD_SUCCESS = 'MESSAGE_DATA_DOWNLOAD_SUCCESS'

export const SHIFT_CREATOR_LIST_SEARCH = 'SHIFT_CREATOR_LIST_SEARCH'
export const SHIFT_CREATOR_LIST_SEARCH_FAILURE = 'SHIFT_CREATOR_LIST_SEARCH_FAILURE'
export const SHIFT_CREATOR_LIST_SEARCH_SUCCESS = 'SHIFT_CREATOR_LIST_SEARCH_SUCCESS'
export const SHIFT_CREATOR_EDIT_SEARCH = 'SHIFT_CREATOR_EDIT_SEARCH'
export const SHIFT_CREATOR_EDIT_SEARCH_FAILURE = 'SHIFT_CREATOR_EDIT_SEARCH_FAILURE'
export const SHIFT_CREATOR_EDIT_SEARCH_SUCCESS = 'SHIFT_CREATOR_EDIT_SEARCH_SUCCESS'
export const SHIFT_CREATOR_UPDATE = 'SHIFT_CREATOR_UPDATE'
export const SHIFT_CREATOR_UPDATE_FAILURE = 'SHIFT_CREATOR_UPDATE_FAILURE'
export const SHIFT_CREATOR_UPDATE_SUCCESS = 'SHIFT_CREATOR_UPDATE_SUCCESS'

export const SHIFT_CLASS_LIST = 'SHIFT_CLASS_LIST'
export const SHIFT_CLASS_LIST_FAILURE = 'SHIFT_CLASS_LIST_FAILURE'
export const SHIFT_CLASS_LIST_SUCCESS = 'SHIFT_CLASS_LIST_SUCCESS'
export const SHIFT_CLASS_CREATE = 'SHIFT_CLASS_CREATE'
export const SHIFT_CLASS_CREATE_FAILURE = 'SHIFT_CLASS_CREATE_FAILURE'
export const SHIFT_CLASS_CREATE_SUCCESS = 'SHIFT_CLASS_CREATE_SUCCESS'
export const SHIFT_CLASS_UPDATE = 'SHIFT_CLASS_UPDATE'
export const SHIFT_CLASS_UPDATE_FAILURE = 'SHIFT_CLASS_UPDATE_FAILURE'
export const SHIFT_CLASS_UPDATE_SUCCESS = 'SHIFT_CLASS_UPDATE_SUCCESS'
export const SHIFT_CLASS_DELETE = 'SHIFT_CLASS_DELETE'
export const SHIFT_CLASS_DELETE_FAILURE = 'SHIFT_CLASS_DELETE_FAILURE'
export const SHIFT_CLASS_DELETE_SUCCESS = 'SHIFT_CLASS_DELETE_SUCCESS'

export const SHIFT_CONDITION_LIST = 'SHIFT_CONDITION_LIST'
export const SHIFT_CONDITION_LIST_FAILURE = 'SHIFT_CONDITION_LIST_FAILURE'
export const SHIFT_CONDITION_LIST_SUCCESS = 'SHIFT_CONDITION_LIST_SUCCESS'
export const SHIFT_CONDITION_DELETE = 'SHIFT_CONDITION_DELETE'
export const SHIFT_CONDITION_DELETE_FAILURE = 'SHIFT_CONDITION_DELETE_FAILURE'
export const SHIFT_CONDITION_DELETE_SUCCESS = 'SHIFT_CONDITION_DELETE_SUCCESS'
export const SHIFT_CONDITION_EDIT = 'SHIFT_CONDITION_EDIT'
export const SHIFT_CONDITION_EDIT_FAILURE = 'SHIFT_CONDITION_EDIT_FAILURE'
export const SHIFT_CONDITION_EDIT_SUCCESS = 'SHIFT_CONDITION_EDIT_SUCCESS'
export const SHIFT_CONDITION_UPDATE = 'SHIFT_CONDITION_UPDATE'
export const SHIFT_CONDITION_UPDATE_FAILURE = 'SHIFT_CONDITION_UPDATE_FAILURE'
export const SHIFT_CONDITION_UPDATE_SUCCESS = 'SHIFT_CONDITION_UPDATE_SUCCESS'

export const SHIFT_CREATE_GET = 'SHIFT_CREATE_GET'
export const SHIFT_CREATE_GET_FAILURE = 'SHIFT_CREATE_GET_FAILURE'
export const SHIFT_CREATE_GET_SUCCESS = 'SHIFT_CREATE_GET_SUCCESS'
export const SHIFT_CREATE_UPDATE = 'SHIFT_CREATE_UPDATE'
export const SHIFT_CREATE_UPDATE_FAILURE = 'SHIFT_CREATE_UPDATE_FAILURE'
export const SHIFT_CREATE_UPDATE_SUCCESS = 'SHIFT_CREATE_UPDATE_SUCCESS'

export const PRINT_ATTENDANCE = 'PRINT_ATTENDANCE'
export const PRINT_ATTENDANCE_FAILURE = 'PRINT_ATTENDANCE_FAILURE'
export const PRINT_ATTENDANCE_SUCCESS = 'PRINT_ATTENDANCE_SUCCESS'
export const PRINT_ATTENDANCE_REMOVE_PDF = 'PRINT_ATTENDANCE_REMOVE_PDF'
export const PRINT_ATTENDANCE_REMOVE_PDF_FAILURE = 'PRINT_ATTENDANCE_REMOVE_PDF_FAILURE'
export const PRINT_ATTENDANCE_REMOVE_PDF_SUCCESS = 'PRINT_ATTENDANCE_REMOVE_PDF_SUCCESS'

export const MAGAZINE_LIST_SEARCH = 'MAGAZINE_LIST_SEARCH'
export const MAGAZINE_LIST_SEARCH_FAILURE = 'MAGAZINE_LIST_SEARCH_FAILURE'
export const MAGAZINE_LIST_SEARCH_SUCCESS = 'MAGAZINE_LIST_SEARCH_SUCCESS'
export const MAGAZINE_DELETE = 'MAGAZINE_DELETE'
export const MAGAZINE_DELETE_FAILURE = 'MAGAZINE_DELETE_FAILURE'
export const MAGAZINE_DELETE_SUCCESS = 'MAGAZINE_DELETE_SUCCESS'
export const MAGAZINE_CREATE = 'MAGAZINE_CREATE'
export const MAGAZINE_CREATE_FAILURE = 'MAGAZINE_CREATE_FAILURE'
export const MAGAZINE_CREATE_SUCCESS = 'MAGAZINE_CREATE_SUCCESS'
export const MAGAZINE_EDIT = 'MAGAZINE_EDIT'
export const MAGAZINE_EDIT_FAILURE = 'MAGAZINE_EDIT_FAILURE'
export const MAGAZINE_EDIT_SUCCESS = 'MAGAZINE_EDIT_SUCCESS'
export const MAGAZINE_UPDATE = 'MAGAZINE_UPDATE'
export const MAGAZINE_UPDATE_SUCCESS = 'MAGAZINE_UPDATE_SUCCESS'
export const MAGAZINE_UPDATE_FAILURE = 'MAGAZINE_UPDATE_FAILURE'

export const HUMAN_STAFF_LIST_SEARCH = 'HUMAN_STAFF_LIST_SEARCH'
export const HUMAN_STAFF_LIST_SEARCH_SUCCESS = 'HUMAN_STAFF_LIST_SEARCH_SUCCESS'
export const HUMAN_STAFF_LIST_SEARCH_FAILURE = 'HUMAN_STAFF_LIST_SEARCH_FAILURE'
export const HUMAN_STAFF_UPDATE = 'HUMAN_STAFF_UPDATE'
export const HUMAN_STAFF_UPDATE_SUCCESS = 'HUMAN_STAFF_UPDATE_SUCCESS'
export const HUMAN_STAFF_UPDATE_FAILURE = 'HUMAN_STAFF_UPDATE_FAILURE'

export const WILL_MUST_GET = 'WILL_MUST_GET'
export const WILL_MUST_GET_SUCCESS = 'WILL_MUST_GET_SUCCESS'
export const WILL_MUST_GET_FAILURE = 'WILL_MUST_GET_FAILURE'

export const WILL_MUST_DOWNLOAD = 'WILL_MUST_DOWNLOAD'
export const WILL_MUST_DOWNLOAD_SUCCESS = 'WILL_MUST_DOWNLOAD_SUCCESS'
export const WILL_MUST_DOWNLOAD_FAILURE = 'WILL_MUST_DOWNLOAD_FAILURE'

export const WILL_MUST_CSV_DOWNLOAD = 'WILL_MUST_CSV_DOWNLOAD'
export const WILL_MUST_CSV_DOWNLOAD_SUCCESS = 'WILL_MUST_CSV_DOWNLOAD_SUCCESS'
export const WILL_MUST_CSV_DOWNLOAD_FAILURE = 'WILL_MUST_CSV_DOWNLOAD_FAILURE'

export const WILL_MUST_DELETE = 'WILL_MUST_DELETE'
export const WILL_MUST_DELETE_SUCCESS = 'WILL_MUST_DELETE_SUCCESS'
export const WILL_MUST_DELETE_FAILURE = 'WILL_MUST_DELETE_FAILURE'

export const GET_REFERRAL_LIST = 'GET_REFERRAL_LIST'
export const GET_REFERRAL_LIST_SUCCESS = 'GET_REFERRAL_LIST_SUCCESS'
export const GET_REFERRAL_LIST_FAILURE = 'GET_REFERRAL_LIST_FAILURE'

export const CHANGE_PUBLISH = 'CHANGE_PUBLISH'
export const CHANGE_PUBLISH_SUCCESS = 'CHANGE_PUBLISH_SUCCESS'
export const CHANGE_PUBLISH_FAILURE = 'CHANGE_PUBLISH_FAILURE'

export const GET_REFERRAL_DETAIL = 'GET_REFERRAL_DETAIL'
export const GET_REFERRAL_DETAIL_SUCCESS = 'GET_REFERRAL_DETAIL_SUCCESS'
export const GET_REFERRAL_DETAIL_FAILURE = 'GET_REFERRAL_DETAIL_FAILURE'

export const REFERRAL_UPDATE = 'REFERRAL_UPDATE'
export const REFERRAL_UPDATE_SUCCESS = 'REFERRAL_UPDATE_SUCCESS'
export const REFERRAL_UPDATE_FAILURE = 'REFERRAL_UPDATE_FAILURE'

export const GET_INTRODUCTION_NOTICE_COUNT = 'GET_INTRODUCTION_NOTICE_COUNT'
export const GET_INTRODUCTION_NOTICE_COUNT_SUCCESS = 'GET_INTRODUCTION_NOTICE_COUNT_SUCCESS'
export const GET_INTRODUCTION_NOTICE_COUNT_FAILURE = 'GET_INTRODUCTION_NOTICE_COUNT_FAILURE'

export const GET_INTRODUCTION_LIST = 'GET_INTRODUCTION_LIST'
export const GET_INTRODUCTION_LIST_SUCCESS = 'GET_INTRODUCTION_LIST_SUCCESS'
export const GET_INTRODUCTION_LIST_FAILURE = 'GET_INTRODUCTION_LIST_FAILURE'

export const GET_INTRODUCTION_DETAIL = 'GET_INTRODUCTION_DETAIL'
export const GET_INTRODUCTION_DETAIL_SUCCESS = 'GET_INTRODUCTION_DETAIL_SUCCESS'
export const GET_INTRODUCTION_DETAIL_FAILURE = 'GET_INTRODUCTION_DETAIL_FAILURE'

export const PATCH_INTRODUCTION_COMPLETE = 'PATCH_INTRODUCTION_COMPLETE'
export const PATCH_INTRODUCTION_COMPLETE_SUCCESS = 'PATCH_INTRODUCTION_COMPLETE_SUCCESS'
export const PATCH_INTRODUCTION_COMPLETE_FAILURE = 'PATCH_INTRODUCTION_COMPLETE_FAILURE'

export const PRINT_INTRODUCTION = 'PRINT_INTRODUCTION'
export const PRINT_INTRODUCTION_SUCCESS = 'PRINT_INTRODUCTION_SUCCESS'
export const PRINT_INTRODUCTION_FAILURE = 'PRINT_INTRODUCTION_FAILURE'

export const GET_QUESTION_ALL = 'GET_QUESTION_ALL'
export const GET_QUESTION_LIST = 'GET_QUESTION_LIST'
export const QUESTION_DELETE = 'QUESTION_DELETE'
export const QUESTION_CREATE = 'QUESTION_CREATE'
export const GET_QUESTION_DETAIL = 'GET_QUESTION_DETAIL'
export const QUESTION_UPDATE = 'QUESTION_UPDATE'

export const GET_STEPUP_LIST = 'GET_STEPUP_LIST'
export const STEPUP_CREATE = 'STEPUP_CREATE'
export const GET_STEPUP_DETAIL = 'GET_STEPUP_DETAIL'
export const GET_STEPUP_SHOW = 'GET_STEPUP_SHOW'
export const DELETE_STEPUP = 'DELETE_STEPUP'
export const STEPUP_UPDATE = 'STEPUP_UPDATE'
export const USER_GET_BY_SHOP = 'USER_GET_BY_SHOP'
export const CSV_STEPUP_ANSWER = 'CSV_STEPUP_ANSWER'
export const IS_STEPUP_ENTRY_EXIST = 'IS_STEPUP_ENTRY_EXIST'
export const STEPUP_FUTURE_SHOP_CHANGE_CHECK = 'STEPUP_FUTURE_SHOP_CHANGE_CHECK'
export const STEPUP_FUTURE_USERTYPE_CHANGE_CHECK = 'STEPUP_FUTURE_USERTYPE_CHANGE_CHECK'
export const ES_MYCARD_HUMAN_CSV = 'ES_MYCARD_HUMAN_CSV'
export const ES_MYCARD_CARD_CSV = 'ES_MYCARD_CARD_CSV'

export const GET_COMPANY_NOTICE_LIST = 'GET_COMPANY_NOTICE_LIST'
export const GET_COMPANY_NOTICE = 'GET_COMPANY_NOTICE'
export const CREATE_COMPANY_NOTICE = 'CREATE_COMPANY_NOTICE'
export const UPDATE_COMPANY_NOTICE = 'UPDATE_COMPANY_NOTICE'
export const DELETE_COMPANY_NOTICE = 'DELETE_COMPANY_NOTICE'
export const GET_COMPANY_NOTICE_RESULT_CSV = 'GET_COMPANY_NOTICE_RESULT_CSV'

export const GET_SUPPLIER_LIST = 'GET_SUPPLIER_LIST'
export const GET_SUPPLIER = 'GET_SUPPLIER'
export const CREATE_MASTER_SUPPLIER = 'CREATE_MASTER_SUPPLIER'
export const UPDATE_MASTER_SUPPLIER = 'UPDATE_MASTER_SUPPLIER'
export const DELETE_SUPPLIER = 'DELETE_SUPPLIER'
export const GET_SUPPLIER_PRODUCTS = 'GET_SUPPLIER_PRODUCTS'
export const CONSUMABLE_ITEM_GET = 'CONSUMABLE_ITEM_GET'
export const CONSUMABLE_ITEM_CREATE = 'CONSUMABLE_ITEM_CREATE'
export const CONSUMABLE_ITEM_UPDATE = 'CONSUMABLE_ITEM_UPDATE'
export const CONSUMABLE_ITEM_SHOW = 'CONSUMABLE_ITEM_SHOW'
export const CONSUMABLE_ITEM_DELETE = 'CONSUMABLE_ITEM_DELETE'
export const CONSUMABLE_ITEM_IMAGE_UPLOAD = 'CONSUMABLE_ITEM_IMAGE_UPLOAD'
export const GET_CATEGORY_LIST = 'GET_CATEGORY_LIST'
export const GET_CATEGORY = 'GET_CATEGORY'
export const CREATE_MASTER_CATEGORY = 'CREATE_MASTER_CATEGORY'
export const UPDATE_MASTER_CATEGORY = 'UPDATE_MASTER_CATEGORY'
export const DELETE_CATEGORY = 'DELETE_CATEGORY'
export const GET_CATEGORY_PRODUCTS = 'GET_CATEGORY_PRODUCTS'

export const GET_HOLDPLACE_LIST = 'GET_HOLDPLACE_LIST'
export const GET_HOLDPLACE = 'GET_HOLDPLACE'
export const CREATE_MASTER_HOLDPLACE = 'CREATE_MASTER_HOLDPLACE'
export const UPDATE_MASTER_HOLDPLACE = 'UPDATE_MASTER_HOLDPLACE'
export const DELETE_HOLDPLACE = 'DELETE_HOLDPLACE'
export const GET_HOLDPLACE_PRODUCTS = 'GET_HOLDPLACE_PRODUCTS'

export const GET_TANOMAIL_LIST = 'GET_TANOMAIL_LIST'
export const GET_TANOMAIL = 'GET_TANOMAIL'
export const CREATE_MASTER_TANOMAIL = 'CREATE_MASTER_TANOMAIL'
export const UPDATE_MASTER_TANOMAIL = 'UPDATE_MASTER_TANOMAIL'
export const DELETE_TANOMAIL = 'DELETE_TANOMAIL'

export const GET_CONSUMABLE_ITEM_SHOP_STOCK_COUNT = 'GET_CONSUMABLE_ITEM_SHOP_STOCK_COUNT'
export const GET_CONSUMABLE_ITEM_SHOP_STOCK_COUNT_EDIT = 'GET_CONSUMABLE_ITEM_SHOP_STOCK_COUNT_EDIT'
export const UPDATE_CONSUMABLE_ITEM_SHOP_STOCK_COUNT = 'UPDATE_CONSUMABLE_ITEM_SHOP_STOCK_COUNT'

export const STOCK_CHECK_PERIOD = 'STOCK_CHECK_PERIOD'
export const STOCK_CHECK_PERIOD_STORE = 'STOCK_CHECK_PERIOD_STORE'

export const SHOP_ORDERS_ALL_GET = 'SHOP_ORDERS_ALL_GET'
export const SHOP_ORDER_GET = 'SHOP_ORDER_GET'
export const SHOP_ORDER_HOLD_ON_PLACES = 'SHOP_ORDER_HOLD_ON_PLACES'
export const SHOP_ORDER_SUPPLIERS = 'SHOP_ORDER_SUPPLIERS'

export const SHOP_ORDER_DETAIL_GET = 'SHOP_ORDER_DETAIL_GET'
export const SHOP_ORDER_DETAIL_UPDATE = 'SHOP_ORDER_DETAIL_UPDATE'
export const SHOP_ORDER_UPDATE = 'SHOP_ORDER_UPDATE'
export const SHOP_ORDER_UPDATE_ALL = 'SHOP_ORDER_UPDATE_ALL'
export const SHOP_ORDERS_HISTORY_LIST = 'SHOP_ORDERS_HISTORY_LIST'
export const SHOP_ORDERS_HISTORY_SEARCH_ITEM_GET = 'SHOP_ORDERS_HISTORY_SEARCH_ITEM_GET'

export const STOCK_OUTPUT_TANOMAIL = 'STOCK_OUTPUT_TANOMAIL'
export const STOCK_OUTPUT_PDF = 'STOCK_OUTPUT_PDF'

export const GET_STOCK_AVAILABLE_DATE = 'GET_STOCK_AVAILABLE_DATE'
export const STOCK_ANALYSIS_CSV = 'STOCK_ANALYSIS_CSV'

export const GET_NORMAL_QUESTION_ALL = 'GET_NORMAL_QUESTION_ALL'
export const GET_NORMAL_QUESTION_LIST = 'GET_NORMAL_QUESTION_LIST'
export const NORMAL_QUESTION_DELETE = 'NORMAL_QUESTION_DELETE'
export const NORMAL_QUESTION_CREATE = 'NORMAL_QUESTION_CREATE'
export const GET_NORMAL_QUESTION_DETAIL = 'GET_NORMAL_QUESTION_DETAIL'
export const NORMAL_QUESTION_UPDATE = 'NORMAL_QUESTION_UPDATE'

export const GET_PERSONNEL_QUESTION_ALL = 'GET_PERSONNEL_QUESTION_ALL'
export const GET_BUSINESS_QUESTION_ALL = 'GET_BUSINESS_QUESTION_ALL'
export const GET_ABILITY_QUESTION_LIST = 'GET_ABILITY_QUESTION_LIST'
export const ABILITY_QUESTION_DELETE = 'ABILITY_QUESTION_DELETE'
export const ABILITY_QUESTION_CREATE = 'ABILITY_QUESTION_CREATE'
export const GET_ABILITY_QUESTION_DETAIL = 'GET_ABILITY_QUESTION_DETAIL'
export const ABILITY_QUESTION_UPDATE = 'ABILITY_QUESTION_UPDATE'

export const GET_EVALUATE_QUESTION_ALL = 'GET_EVALUATE_QUESTION_ALL'
export const GET_EVALUATE_QUESTION_LIST = 'GET_EVALUATE_QUESTION_LIST'
export const EVALUATE_QUESTION_DELETE = 'EVALUATE_QUESTION_DELETE'
export const EVALUATE_QUESTION_CREATE = 'EVALUATE_QUESTION_CREATE'
export const GET_EVALUATE_QUESTION_DETAIL = 'GET_EVALUATE_QUESTION_DETAIL'
export const EVALUATE_QUESTION_UPDATE = 'EVALUATE_QUESTION_UPDATE'
export const CSV_EVALUATE_QUESTION_ANSWER = 'CSV_EVALUATE_QUESTION_ANSWER'

export const GET_MASTER_SERVICE_QUESTION_ALL = 'GET_MASTER_SERVICE_QUESTION_ALL'
export const GET_MASTER_SERVICE_QUESTION_LIST = 'GET_MASTER_SERVICE_QUESTION_LIST'
export const MASTER_SERVICE_QUESTION_DELETE = 'MASTER_SERVICE_QUESTION_DELETE'
export const MASTER_SERVICE_QUESTION_CREATE = 'MASTER_SERVICE_QUESTION_CREATE'
export const GET_MASTER_SERVICE_QUESTION_DETAIL = 'GET_MASTER_SERVICE_QUESTION_DETAIL'
export const MASTER_SERVICE_QUESTION_UPDATE = 'MASTER_SERVICE_QUESTION_UPDATE'
export const GET_SERVICE_QUESTION_CATEGORY_ALL = 'GET_SERVICE_QUESTION_CATEGORY_ALL'
export const GET_SERVICE_QUESTION_CATEGORY_ALL_SUCCESS = 'GET_SERVICE_QUESTION_CATEGORY_ALL_SUCCESS'
export const GET_SERVICE_QUESTION_CATEGORY_ALL_FAILURE = 'GET_SERVICE_QUESTION_CATEGORY_ALL_FAILURE'

export const GET_SERVICE_QUESTION_LIST = 'GET_SERVICE_QUESTION_LIST'
export const GET_SERVICE_QUESTION_RESULT_LIST = 'GET_SERVICE_QUESTION_RESULT_LIST'
export const GET_SERVICE_QUESTION_DETAIL = 'GET_SERVICE_QUESTION_DETAIL'
export const SERVICE_QUESTION_CREATE = 'SERVICE_QUESTION_CREATE'
export const SERVICE_QUESTION_DELETE = 'SERVICE_QUESTION_DELETE'
export const SERVICE_QUESTION_UPDATE = 'SERVICE_QUESTION_UPDATE'
export const GET_SERVICE_RESULT_LIST = 'GET_SERVICE_RESULT_LIST'
export const GET_SERVICE_RESULT_DETAIL = 'GET_SERVICE_RESULT_DETAIL'
export const DOWNLOAD_SERVICE_RESULT_DETAIL = 'DOWNLOAD_SERVICE_RESULT_DETAIL'
export const DELETE_SERVICE_RESULT_DETAIL = 'DELETE_SERVICE_RESULT_DETAIL'
export const GET_SERVICE_RESULT_COMMENT = 'GET_SERVICE_RESULT_COMMENT'
export const UPDATE_SERVICE_RESULT_COMMENT = 'UPDATE_SERVICE_RESULT_COMMENT'
export const DOWNLOAD_SERVICE_RESULT_LIST = 'DOWNLOAD_SERVICE_RESULT_LIST'
export const DELETE_SERVICE_RESULT_LIST = 'DELETE_SERVICE_RESULT_LIST'

export const SORT_MACHINE_ORDER_SHOP = 'SORT_MACHINE_ORDER_SHOP'
export const DOWNLOAD_SHIFT = 'DOWNLOAD_SHIFT'
export const DOWNLOAD_SHIFT_FAILURE = 'DOWNLOAD_SHIFT_FAILURE'
export const DOWNLOAD_SHIFT_SUCCESS = 'DOWNLOAD_SHIFT_SUCCESS'
export const DELETE_SHIFT_FILE = 'DELETE_SHIFT_FILE'

export const GET_SAFETY_CONFIRMATION_LIST = 'GET_SAFETY_CONFIRMATION_LIST'
export const GET_SAFETY_CONFIRMATION_DETAIL = 'GET_SAFETY_CONFIRMATION_DETAIL'
export const CREATE_SAFETY_CONFIRMATION = 'CREATE_SAFETY_CONFIRMATION'
export const UPDATE_SAFETY_CONFIRMATION = 'UPDATE_SAFETY_CONFIRMATION'
export const CLOSE_SAFETY_CONFIRMATION = 'CLOSE_SAFETY_CONFIRMATION'
export const GET_SAFETY_CONFIRMATION_ANSWER_LIST = 'GET_SAFETY_CONFIRMATION_ANSWER_LIST'

export const AREA_ALL_GET = 'AREA_ALL_GET'
export const AREA_ALL_GET_SUCCESS = 'AREA_ALL_GET_SUCCESS'
export const AREA_ALL_GET_FAILURE = 'AREA_ALL_GET_FAILURE'



// WEBPACK FOOTER //
// ./src/store/modules/mutation-types.js